module.exports = __webpack_public_path__ + "img/showcase-4.471ba9fe.png";